import {
  ArrowCircleRightIcon,
  ChatAlt2Icon,
  CogIcon,
  VideoCameraIcon,
} from "@heroicons/react/outline";

const serviceData = [
  {
    id: 1,
    title: "Channels",
    desc: "Stay organised and focused with central spaces for conversations,files, tools and people.",
  },
  {
    id: 2,
    title: "Memento Connect",
    desc: "Collaborate with teams at other companies in the same way you do with teams at your own.",
  },
];

const serviceDataTwo = [
  {
    id: 1,
    title: "Messaging",
    Icon: ChatAlt2Icon,
    Arrow: ArrowCircleRightIcon,
  },
  {
    id: 2,
    title: "Accessibility",
    Icon: CogIcon,
    Arrow: ArrowCircleRightIcon,
  },
  {
    id: 3,
    title: "Voice and video Calls",
    Icon: VideoCameraIcon,
    Arrow: ArrowCircleRightIcon,
  },
];

export { serviceData, serviceDataTwo };
